import { OrganizationIntegrationAccountEntity } from "@common/schemas/organization-integration.schema";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { HStack } from "@design-system/HStack/HStack";

type EntityLabelEntity = Pick<
    OrganizationIntegrationAccountEntity,
    "name" | "iconColor" | "logo"
>;

export const EntityLabel = ({ entity }: { entity: EntityLabelEntity }) => (
    <HStack gap={8} align="center">
        <EntityAvatar size="xs" entity={entity} aria-hidden />
        {entity.name ?? "Untitled entity"}
    </HStack>
);
